import { useMutation, useQuery} from "@tanstack/react-query";
import { useEffect, useState } from "react";
import {  useNavigate, useParams } from "react-router";
import styled from "styled-components";
import { GoBackButton } from "../../../components/GoBackButton";
import { LoadingBackDrop } from "../../../components/loader";
import { getOrdersPricelistOffersById } from "../../../services/orders/pricelist-offers-get-by-id";
import { PricelistOffersGetByIdPayload } from "../../../services/orders/pricelist-offers-get-by-id/types";
import { urlClient } from "../../../utils/url";
import { OfferView } from "../offer-view";
import { statusChandleDataFinalOffer } from "../offer-view-from-email/helpers/pre-selection-data";
import { OfferViewComponent, StatusChandleDataResponse } from "../offer-view-from-email/helpers/types";
import { OfferHasBeenFinallyAccepted } from "../offer-view/components/view-variants/offer-has-been-finally-accepted-or-no-offer-to-final-accept";

export const FinalOfferViewInClientPanel = () => {
    const {id} = useParams();
    const [preOrdersPricelist, setPreOrdersPricelist] = useState<PricelistOffersGetByIdPayload>();
    const [preSelectionData,setPreSelectionData]=useState<StatusChandleDataResponse>();

    const getOrdersPricelistOffersByIdMutation = useMutation(getOrdersPricelistOffersById, {
        onSuccess: (res) => {
            setPreSelectionData(statusChandleDataFinalOffer(res.data?.payload));
            const newRes:PricelistOffersGetByIdPayload={
                id_zamowienie: res.data.payload.id_zamowienie,
                numer_zamowienia: res.data.payload.numer_zamowienia,
                data_zlozenia: res.data.payload.data_zlozenia,
                status_zamowienia: res.data.payload.status_zamowienia,
                opis_uslugi: res.data.payload.opis_uslugi,
                termin_rozpoczecia: res.data.payload.termin_rozpoczecia,
                termin_zakonczenia: res.data.payload.termin_zakonczenia,
                kraj: res.data.payload.kraj,
                wojewodztwo: res.data.payload.wojewodztwo,
                kod_pocztowy: res.data.payload.kod_pocztowy,
                miasto: res.data.payload.miasto,
                miejsce: res.data.payload.miejsce,
                skladowanie_plaskie: res.data.payload.skladowanie_plaskie,
                wysokie_skladowanie:res.data.payload.wysokie_skladowanie,
                polki: res.data.payload.polki,
                warunek_temperaturowy: res.data.payload.warunek_temperaturowy,
                rodzaj_towaru: res.data.payload.rodzaj_towaru,
                opis_towaru: res.data.payload.opis_towaru,
                specjalny_sprzet: res.data.payload.specjalny_sprzet,
                dodatkowe_uwagi: res.data.payload.dodatkowe_uwagi,
                oferty: statusChandleDataFinalOffer(res.data?.payload).data,
                uslugi_zamowione: {
                  cel_zamowienia: res.data.payload.uslugi_zamowione.cel_zamowienia,
                  uslugi_dodatkowe: res.data.payload.uslugi_zamowione.uslugi_dodatkowe,
                  ilosc_dodatkowych:res.data.payload.uslugi_zamowione.ilosc_dodatkowych,
                  uslugi_zamowione_id: res.data.payload.uslugi_zamowione.uslugi_zamowione_id,
              }
            };
            setPreOrdersPricelist(newRes);
        },
        onError: (err:any) => {
          },
    });

    useEffect(() => {
            getOrdersPricelistOffersByIdMutation.mutate({
            id_zamowienie:id,
            token:null,
          })
       
    }, []);

    if (preSelectionData===undefined) {
        return <LoadingBackDrop loading={true} />;
      }
    return (
        <>  
            <ViewNavigation>
                <Redirect>
                    <GoBackButton
                        description={"Powrót"}
                        goToUrl={urlClient.orders}
                    />
                </Redirect>
            </ViewNavigation>
           {preSelectionData?.view===OfferViewComponent.finalOffertView
            ?<OfferView 
                offer_id_from_email={id} 
                data={preOrdersPricelist}
                isFinalOffer={true}
            /> 
              : <OfferHasBeenFinallyAccepted/>

        }
       </>
    );
};

const ViewNavigation = styled.div`
margin-top:-10px;
display: flex;
flex-direction: column;
@media (min-width: 1025px) {
 max-width: 1400px;
 margin-left: 225px;
 margin-right: 50px;
}`;

const Redirect = styled.div`
  display: flex;
  align-items: center;
 `;
  